<template>
  <el-dialog
    title="提案数据新增窗口"
    :visible.sync="visible"
    width="1200px"
    @close="close">

    <el-form :inline="true" :model="PropInsertForm" label-position="right">
      <el-form-item label="观测号">
        <el-input v-model="PropInsertForm.obs_id" autocomplete="off" style="width:180px;"></el-input>
      </el-form-item>
      <el-form-item label="计划号">
        <el-input v-model="PropInsertForm.schedule_id" autocomplete="off" style="width:180px;"></el-input>
      </el-form-item>
      <el-form-item label="数据开始时间TT">
        <el-input v-model="PropInsertForm.tstart" autocomplete="off" style="width:160px;"></el-input>
      </el-form-item>
      <el-form-item label="数据结束时间TT">
        <el-input v-model="PropInsertForm.tsop" autocomplete="off" style="width:160px;"></el-input>
      </el-form-item>
      <el-form-item label="数据开始时间UTC">
        <el-date-picker v-model="PropInsertForm.start_utc" value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-ddTHH:mm:ss"  type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="数据结束时间UTC">
        <el-date-picker v-model="PropInsertForm.stop_utc" value-format="yyyy-MM-ddTHH:mm:ss" format="yyyy-MM-ddTHH:mm:ss" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="数据时长">
        <el-input v-model="PropInsertForm.duration" autocomplete="off" style="width:120px;"></el-input>
      </el-form-item>
      <el-form-item label="观测前Slew时长">
        <el-input v-model="PropInsertForm.pre_slew" autocomplete="off" style="width:110px;"></el-input>
      </el-form-item>
      <el-form-item label="观测后Slew时长">
        <el-input v-model="PropInsertForm.post_slew" autocomplete="off" style="width:110px;"></el-input>
      </el-form-item>
      <el-form-item label="观测目标">
        <el-input v-model="PropInsertForm.target" autocomplete="off" style="width:290px;"></el-input>
      </el-form-item>
      <el-form-item label="观测模式">
        <el-select style="width:110px;" v-model="PropInsertForm.obs_mode"  filterable placeholder="观测模式">
              <el-option
                  v-for="item in obsmode_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据模式">
        <el-select style="width:110px;" v-model="PropInsertForm.data_mode"  filterable placeholder="数据模式">
              <el-option
                  v-for="item in datamode_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="观测提案">
        <el-input v-model="PropInsertForm.proposal" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="观测者">
        <el-input v-model="PropInsertForm.observer" autocomplete="off" style="width:290px;"></el-input>
      </el-form-item>
      <el-form-item label="提案类型">
        <el-select style="width:110px;" v-model="PropInsertForm.ptype"  filterable placeholder="提案类型">
              <el-option
                  v-for="item in proposaltype_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据状态">
        <el-select style="width:130px;" v-model="PropInsertForm.status"  filterable placeholder="数据状态">
              <el-option
                  v-for="item in status_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="ra">
        <el-input v-model="PropInsertForm.ra" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="dec">
        <el-input v-model="PropInsertForm.dec" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="扫描速度">
        <el-input v-model="PropInsertForm.speed" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="扫描间隔">
        <el-input v-model="PropInsertForm.interval" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="扫描半径">
        <el-input v-model="PropInsertForm.radius" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="偏轴标记">
        <el-input v-model="PropInsertForm.offset" autocomplete="off" style="width:200px;"></el-input>
      </el-form-item>
      <el-form-item label="权属">
        <el-input v-model="PropInsertForm.owner" autocomplete="off" style="width:220px;"></el-input>
      </el-form-item>
      <el-form-item label="公开">
        <el-select style="width:110px;" v-model="PropInsertForm.isopen"  filterable placeholder="是否公开">
              <el-option
                  v-for="item in open_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="数据归档日期">
        <el-date-picker v-model="PropInsertForm.archive_time" value-format="yyyy-MM-dd HH:mm" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="数据发布日期">
        <el-date-picker v-model="PropInsertForm.release_time" value-format="yyyy-MM-dd HH:mm" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="数据公开日期">
        <el-date-picker v-model="PropInsertForm.open_time" value-format="yyyy-MM-dd HH:mm" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="l1_file_id">
        <el-input v-model="PropInsertForm.l1_file_id" autocomplete="off" style="width:150px;"></el-input>
      </el-form-item>
      <el-form-item label="l15_file_id">
        <el-input v-model="PropInsertForm.l15_file_id" autocomplete="off" style="width:150px;"></el-input>
      </el-form-item>
      <el-form-item label="l2_file_id">
        <el-input v-model="PropInsertForm.l2_file_id" autocomplete="off" style="width:150px;"></el-input>
      </el-form-item>
      <el-form-item label="生成时间">
        <el-date-picker v-model="PropInsertForm.create_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="生成者">
        <el-input v-model="PropInsertForm.create_by" autocomplete="off" style="width:110px;"></el-input>
      </el-form-item>
      <el-form-item label="更新时间">
        <el-date-picker v-model="PropInsertForm.update_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width:195px;"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新者">
        <el-input v-model="PropInsertForm.update_by" autocomplete="off" style="width:110px;"></el-input>
      </el-form-item>     
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {datastatus_IE,DataMode,proposaltype_IE,ObsMode,Iopen_IE} from '../common';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      PropInsertForm:{
        id:'', 
        obs_id:'', 
        schedule_id:'', 
        tstart:'',
        tsop:'',
        start_utc:'',
        stop_utc:'',
        duration:'',
        pre_slew:'',
        post_slew:'',
        target:'',
        obs_mode:'',
        data_mode:'',
        proposal:'',
        observer:'',
        ptype:'',
        status:'',
        ra:'', 
        dec:'',
        speed:'',
        interval:'',
        radius:'',
        offset:'',
        owner:'',
        isopen:'', 
        archive_time:'',
        release_time:'',
        open_time:'',
        l1_file_id:'',
        l15_file_id:'',
        l2_file_id:'',
        create_time:'',
        create_by:'',
        update_time:'',
        update_by:'', 
      },
      obsmode_list:ObsMode,
      status_list:datastatus_IE,
      datamode_list:DataMode,
      proposaltype_list:proposaltype_IE,
      open_list:Iopen_IE,
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.PropInsertForm.obs_id = data.obs_id;
      this.PropInsertForm.schedule_id = data.schedule_id;
      this.PropInsertForm.tstart = data.tstart;
      this.PropInsertForm.tsop = data.tsop;
      this.PropInsertForm.start_utc = data.start_utc;
      this.PropInsertForm.stop_utc = data.stop_utc;
      this.PropInsertForm.duration = data.duration;
      this.PropInsertForm.pre_slew = data.pre_slew;
      this.PropInsertForm.post_slew = data.post_slew;
      this.PropInsertForm.target = data.target;
      this.PropInsertForm.obs_mode = data.obs_mode;
      this.PropInsertForm.data_mode = data.data_mode;
      this.PropInsertForm.proposal = data.proposal;
      this.PropInsertForm.observer = data.observer;
      this.PropInsertForm.ptype = data.ptype;
      this.PropInsertForm.status = data.status;
      this.PropInsertForm.ra = data.ra;
      this.PropInsertForm.dec = data.dec;
      this.PropInsertForm.speed = data.speed;
      this.PropInsertForm.interval = data.interval;
      this.PropInsertForm.radius = data.radius;
      this.PropInsertForm.offset = data.offset;
      this.PropInsertForm.owner = data.owner;
      this.PropInsertForm.isopen = data.isopen;
      this.PropInsertForm.archive_time = data.archive_time;
      this.PropInsertForm.release_time = data.release_time;
      this.PropInsertForm.open_time = data.open_time;
      this.PropInsertForm.l1_file_id = data.l1_file_id;
      this.PropInsertForm.l15_file_id = data.l15_file_id;
      this.PropInsertForm.l2_file_id = data.l2_file_id;
      this.PropInsertForm.create_time = data.create_time;
      this.PropInsertForm.create_by = data.create_by;
      this.PropInsertForm.update_time = data.update_time;
      this.PropInsertForm.update_by = data.update_by;      
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.PropInsertForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
